<template>
  <v-form autocomplete="off">
    <v-row>
      <v-col cols="12" sm="6" md="3" class="mt-2">
        <v-select
          :items="categories"
          v-model="form.category"
          @change="CategoryChanged"
          return-object
          item-value="id"
          item-text="name"
          :menu-props="{ maxHeight: '400' }"
          :no-data-text="loading ? 'Список загружается...' : 'Список пуст'"
          label="Категория"
          persistent-hint
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="mt-2">
        <v-select
          :items="productsList"
          :disabled="!form.category"
          @change="$emit('change', true)"
          v-model="form.product"
          return-object
          item-value="id"
          item-text="name"
          :menu-props="{ maxHeight: '400' }"
          :no-data-text="loading ? 'Список загружается...' : 'Список пуст'"
          label="Товар"
          persistent-hint
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="mt-2">
        <v-select
          :items="coatingsList"
          v-model="form.coating"
          return-object
          item-value="id"
          item-text="name"
          :disabled="!form.category || !form.product || !coatingsList.length"
          :menu-props="{ maxHeight: '400' }"
          :no-data-text="loading ? 'Список загружается...' : 'Список пуст'"
          label="Покрытие"
          persistent-hint
        ></v-select>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="mt-2">
        <v-text-field
          type="text"
          :label="form.product && form.product.unit ? `Количество (${form.product.unit.short_name})` : 'Количество'"
          :disabled="!form.category || !form.product"
          v-model="form.qty"
          v-mask="'######'"
          required
          :error="qtyError"
          :hint="hint"
          :persistent-hint="true"
        ></v-text-field>
      </v-col>
      <v-col cols="12" sm="6" md="3" class="pt-0 d-flex justify-center align-center">
        <v-btn
          @click="AddProduct"
          :loading="localLoading"
          class="pt-0"
          color="success"
          block
          :disabled="localLoading || loading || !valid || !qtyValid"
        >
          <v-icon left dark>mdi-plus-circle-outline</v-icon>
          Добавить товар
        </v-btn>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
  const initialForm = {
    category: null,
    product: null,
    coating: null,
    bonuses: 0,
    qty: '',
  };

  export default {
    props: ['categories', 'isNewSale', 'object_id'],
    data() {
      return {
        form: { ...initialForm },
        hint: '',
        qtyError: false,
        localLoading: false,
      };
    },
    computed: {
      loading() {
        return this.$store.state.loading;
      },
      productsList() {
        return this.$store.state.sales.productsList || [];
      },
      coatingsList() {
        return this.$store.state.sales.coatingsList || [];
      },
      qtyValid() {
        console.log(this.form.qty, this.form.product);
        if (this.form && this.form.qty && this.form.product) {
          return !this.form.product.multiple || this.form?.qty % this.form?.product?.multiple === 0;
        }
        return false;
      },
      valid() {
        return (
          this.form.category && this.form.product
          && this.form.qty
        );
      },
    },
    methods: {
      /**
       * Было изменено поле категория
       * @param {object} category - объект выбранной категории
       */
      CategoryChanged(category) {
        this.form.product = null;
        this.form.coating = null;
        this.form.qty = '';
        this.$store.dispatch('sales/GetProducts', category.id);
        this.$store.dispatch('sales/GetСoatings', category.id);
        this.$emit('change', true);
      },
      /** Подсчет бонусов за товар */
      CalculateBonuses() {
        const app = this;
        app.localLoading = true;
        if (app.object_id === null) {
          app.form.bonuses = 0;
          app.hint = 'ошибка подсчета, не задан объект';
          return;
        }
        if (app.form.qty) {
          app.hint = 'подсчет баллов...';
          app.$store.dispatch('sales/CalculatedBonuses', {
            object_id: app.object_id,
            product_id: app.form.product.id,
            quantity: app.form.qty,
            profile_id: app.$store.state.profile_id,
          })
            .then((data) => {
              if (!data.bonuses && data.comment) {
                app.hint = data.comment;
                app.qtyError = true;
              } else {
                app.form.bonuses = data.bonuses;
                app.hint = `Количество бонусов: ${data.bonuses} `;
                app.qtyError = false;
              }
            })
            .catch((e) => {
              app.form.bonuses = 0;
              app.hint = 'ошибка подсчёта';
              console.warn(e);
            })
            .finally(() => {
              app.localLoading = false;
            });
        }
      },
      /** Добавление товара в список */
      AddProduct() {
        const { form } = this;
        form.idx = (new Date()).getTime().toString();
        form.qty *= 1;
        this.$emit('add', form);
        this.form = { ...initialForm };
        this.hint = '';
        this.qtyError = false;
        this.$emit('change', false);
      },
    },
  };
</script>
